module.exports = __webpack_require__.p + "925443e9b27cb9be42a3062f2312978a.jpg";